import { useMutation } from 'react-query';

import api from '@root/api';

export default function useSaveImageDocument() {
  return useMutation(
    ({ documentId, documentImageId, data }) => api.documentImages.save(documentId, documentImageId, data),
  );
}
